import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef } from "vue"

import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import OperatorApplicationExportPayloadDialogInterface
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationExportDialogInterface";
import {computed, ref} from "vue";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "OperatorApplicationExportDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels(["send"], ["update:visible"]),
  setup(__props, { emit: __emit }) {

let emits = __emit;

let isVisible = _useModel<boolean>(__props, "visible");
function close() {
    isVisible.value = false;
}

let model = ref<OperatorApplicationExportPayloadDialogInterface>({
    email: OperatorApplicationConfigInstance.lastEmailForExport,
    forClient: false
});


let contacts = computed(() => {
    return OperatorAccountStore.data.value.organizationContacts.filter(item => !!item.email);
});

function emitApply() {
    let email = model.value.email;
    if (email) {
        emits("send", model.value);
        OperatorApplicationConfigInstance.lastEmailForExport = email;
        close();
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createBlock(MyDialog, {
    title: _unref(__)('Экспорт переписки на Ваш Email'),
    onApply: emitApply,
    form: {labelPosition: 'top', model: _unref(model)},
    visible: _unref(isVisible),
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        rules: _unref(requiredRule),
        label: _unref(__)('Введите ваш Email-адрес:'),
        prop: "email"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _unref(model).email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).email) = $event))
          }, {
            suffix: _withCtx(() => [
              _createVNode(_component_el_dropdown, {
                onCommand: _cache[0] || (_cache[0] = ($event: any) => (_unref(model).email = $event)),
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contacts), (contact, key) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: key,
                          command: contact.email
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(contact.name) + " - " + _toDisplayString(contact.email), 1)
                          ]),
                          _: 2
                        }, 1032, ["command"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(FontAwesomeIcon, {
                    icon: "chevron-down",
                    class: "cursor-pointer mr-1"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["rules", "label"]),
      _createVNode(_component_el_form_item, { "label-width": "0px" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_switch, {
            modelValue: _unref(model).forClient,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).forClient) = $event)),
            class: "mr-2"
          }, null, 8, ["modelValue"]),
          _createTextVNode(" " + _toDisplayString(_unref(__)("Сокращённая версия (для клиента)")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "form", "visible"]))
}
}

})